import { Theme } from "@tvg/fuse/theme";
import React from "react";
import { GlobalConfig, GlobalConfigProvider } from "./context/GlobalConfig";
import { SEOConfig } from "./context/SEOContext";
import DevNav from "./views/DevNav";
import SEOHeading from "./views/SEOHeading";

export interface AppProps extends GlobalConfig, SEOConfig {
  path: string;
}

const App: React.FC<AppProps> = ({ brand, pageType, searchTerm, isBreadcrumbsEnabled, origin, ...props }: AppProps) => {
  return (
    <>
      <Theme brand={brand} />
      <GlobalConfigProvider value={{ brand, pageType, searchTerm, isBreadcrumbsEnabled, origin }}>
        <DevNav />
        <SEOHeading {...props} />
      </GlobalConfigProvider>
    </>
  );
};

export default App;
